import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPhoneCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M4.539 4.539C6.285 2.793 8.829 2 12 2c3.17 0 5.715.793 7.461 2.539S22 8.829 22 12c0 3.17-.793 5.715-2.539 7.461S15.171 22 12 22c-3.17 0-5.715-.793-7.461-2.539S2 15.171 2 12c0-3.17.793-5.715 2.539-7.461M16.875 15.71c.085-.18.125-.365.125-.545 0-.14-.03-.265-.08-.39a.76.76 0 0 0-.276-.32l-1.657-1.175a2 2 0 0 0-.35-.195.8.8 0 0 0-.306-.065.67.67 0 0 0-.355.105q-.174.091-.361.28l-.38.375a.28.28 0 0 1-.206.085.4.4 0 0 1-.125-.02l-.045-.02-.045-.02c-.17-.09-.386-.24-.646-.46-.266-.225-.526-.47-.796-.735q-.39-.399-.726-.79a4 4 0 0 1-.466-.64l-.02-.05-.02-.05a.5.5 0 0 1-.015-.115q-.001-.119.08-.2l.38-.395a1.7 1.7 0 0 0 .28-.355.7.7 0 0 0 .106-.355.8.8 0 0 0-.07-.305 1.7 1.7 0 0 0-.2-.35L9.539 7.37a.8.8 0 0 0-.336-.28.94.94 0 0 0-.405-.09c-.37 0-.721.155-1.042.47q-.397.376-.576.835c-.12.3-.18.625-.18.965q0 .78.36 1.635c.24.565.571 1.135.982 1.705q.624.855 1.397 1.635.78.771 1.643 1.4.857.622 1.722.99.865.366 1.633.365.526-.001.976-.19c.306-.125.576-.32.821-.59.146-.16.256-.33.34-.51'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPhoneCircle)
export default ForwardRef
